import React from "react"

interface Props {
  isChecked: boolean
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  label: string
  disabled?: boolean
}

const Checkbox = (props: Props) => {
  return (
    <div className="checkbox-div">
      <div className="d-flex align-items-center">
        <input
          type="checkbox"
          id={props.label}
          checked={props.isChecked}
          onChange={props.handleChange}
          style={{ width: "1rem", height: "1rem", cursor: "pointer" }}
          disabled={props.disabled}
        />
        <label htmlFor={props.label} style={{ fontWeight: "600", marginLeft: "10px" }}>
          {props.label}
        </label>
      </div>
    </div>
  )
}
export default Checkbox
